import type { BeneficiaryTypeGrantsPayload } from '@Application/SubjectTypeDefinitions/Actions/beneficiaryTypeGrantsFetched';
import SubjectTypeGrantView from '@UI/Store/SubjectTypeDefinitions/Views/SubjectTypeGrantView';

/** Who may use the beneficiary dossier type, with their access level. */
class BeneficiaryTypeGrantsView {
	readonly accountId: number;
	readonly usableBy: readonly SubjectTypeGrantView[];

	constructor(payload: BeneficiaryTypeGrantsPayload, accountId: number) {
		this.accountId = accountId;
		this.usableBy = payload.usableBy.map((grant) => new SubjectTypeGrantView(grant));

		Object.freeze(this);
	}
}

export default BeneficiaryTypeGrantsView;
